// src/components/AtributosSelector/index.js
import AtributosSelector from './AtributosSelector'

export { AtributosSelector }
export default AtributosSelector